import { gql } from '@apollo/client';

export default gql`
  query profile($customerId: String!, $subscriptionSearchType: ProfileSubscriptionSearchType) {
    profile(customerId: $customerId) {
      customerId
      subscriptions(subscriptionSearchType: $subscriptionSearchType) {
        bookingReference
        endDate
        startDate
        travelPassReference
        code
        status
      }
    }
  }
`;
